var _path, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn",
    clipPath: "url(#clip0_57_2164)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.543945 34.8467C0.543945 16.069 15.7663 0.84668 34.5439 0.84668C53.3217 0.84668 68.5439 16.069 68.5439 34.8467C68.5439 53.6245 53.3217 68.8467 34.5439 68.8467C15.7663 68.8467 0.543945 53.6245 0.543945 34.8467Z",
    fill: "#0077B5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_57_2164",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 19,
    width: 33,
    height: 33
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_4612_2108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M51.5439 19.9717H19.6689V51.8467H51.5439V19.9717Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_57_2164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M49.1843 19.9717H22.0222C20.7211 19.9717 19.6689 20.9989 19.6689 22.269V49.5432C19.6689 50.8133 20.7211 51.8467 22.0222 51.8467H49.1843C50.4857 51.8467 51.5439 50.8133 51.5439 49.5493V22.269C51.5439 20.9989 50.4857 19.9717 49.1843 19.9717ZM29.1256 47.1339H24.3941V31.9186H29.1256V47.1339ZM26.7599 29.8455C25.2409 29.8455 24.0144 28.6189 24.0144 27.1062C24.0144 25.5934 25.2409 24.367 26.7599 24.367C28.2726 24.367 29.4992 25.5934 29.4992 27.1062C29.4992 28.6128 28.2726 29.8455 26.7599 29.8455ZM46.8311 47.1339H42.106V39.738C42.106 37.9762 42.0747 35.7037 39.6469 35.7037C37.1877 35.7037 36.8143 37.6275 36.8143 39.6135V47.1339H32.0953V31.9186H36.6275V33.998H36.6898C37.3186 32.8026 38.8624 31.5389 41.1597 31.5389C45.9471 31.5389 46.8311 34.689 46.8311 38.7854V47.1339Z",
    fill: "#F6F6F6"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_2164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white",
    transform: "translate(0.543945 0.84668)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.71e9f030eda069cc7fff48d10405fd4d.svg";
export { ForwardRef as ReactComponent };